import Vue from 'vue'
import Router from 'vue-router'
import store from '@/stores/store'

import login from '@/view/login/login'
import indexw from '@/view/login/indexw'
import indexVue from '@/view/login/index'
import role_list from '@/view/sysdata/roleInfo'
import group_list from '@/view/group/groupInfo'
import group_edit from '@/view/group/groupEdit'
import user_list from '@/view/sysdata/userList'
//项目
import project_list from '@/view/project/projectList'
import project_add from '@/view/project/projectAdd'
import project_edit from '@/view/project/projectEdit'
import project_detail from '@/view/project/projectDetail'
import project_source from '@/view/project/sourceList'
//任务
import task_list from '@/view/task/taskList'
import task_add from '@/view/task/taskAdd'
import task_edit from '@/view/task/taskEdit'
import task_detail from '@/view/task/taskDetail'
//子任务
import subtask_list from '@/view/subtask/subtaskList'
import subtask_add from '@/view/subtask/subtaskAdd'
import subtask_edit from '@/view/subtask/subtaskEdit'
import subtask_detail from '@/view/subtask/subtaskDetail'
//工时
import labour_list from '@/view/labour/labourList'
import labour_add from '@/view/labour/labourAdd'
import labour_edit from '@/view/labour/labourEdit'
import labour_detail from '@/view/labour/labourDetail'
import labour_engineer from '@/view/labour/labourEngineer'
import labour_enter from '@/view/labour/labourEnter'
//假期日历
import holiday_list from '@/view/base/holiday'
//定时任务
import cronJob_list from '@/view/base/listenerJob'
//报表
import engineerReport_list from '@/view/report/engineerReport'
import labourReport_list from '@/view/report/labourReport'
//个人信息
import personnel_list from '@/view/personnel/personnelList'
//项目经理映射管理
import manager_list from '@/view/manager/managerInfo'
import manager_edit from '@/view/manager/managerEdit'

// 重大项目
import majorProjectQuery from '@/view/major/projectQuery/index'
import project3S2S from '@/view/major/project3S2S/index'
import majorProjectApplication from '@/view/major/projectApplication/index'
import majorProjectApproval from '@/view/major/projectApproval/index'
import majorFormallyApproved from '@/view/major/formallyApproved/index'
// import projectDetail from '@/view/major/projectDetail/index'
import commonDocuments from '@/view/major/commonDocuments/index'

// 我的工作台
import configurationItem from '@/view/sysdata/configurationItem/index'
import projectManagerMaintenance from '@/view/sysdata/projectManagerMaintenance'
import workbenchToDo from '@/view/myworkbench/toDo/index'
import workbenchToDoMyFlow from '@/view/myworkbench/myFlow/index'
import workbenchFlowQuery from '@/view/myworkbench/flowQuery/index'

// 服务台帐
import keyFocusProjects from '@/view/keyFocusProjects/index'

// 风险管理
import riskManagement from '@/view/riskmanagement/index'
import riskDashboard from '@/view/riskmanagement/riskDashboard'
import riskAssessmentGuide from '@/view/riskmanagement/riskAssessmentGuide'

//  满意度调查
import satisfactionLevel from '@/view/satisfactionlevel/index'
import satisfactionLevelMarket from '@/view/satisfactionlevel/market'

// 价值客户管理
import informationManagement from '@/view/valuedAccountManagement/informationManagement'
import documentManagement from '@/view/valuedAccountManagement/documentManagement'
import valuedAccountReport from '@/view/valuedAccountManagement/valuedAccountReport'
import accountDetail from '@/view/valuedAccountManagement/accountDetail'

Vue.use(Router)

const router = new Router({
  routes: [
   
    {
      path: '/login',
      name: 'Login',
      component: login
    },
    {
      path: '/indexw',
      name: 'Indexw',
      component: indexw,
      children:[
          //首页
          {
            path: '/index',
            redirect: '/indexw'
          },
          {         
            path: '/indexw',
            name: 'indexVue',
            component: indexVue,
            meta: {
              requireAuth: true,
            }
          },
          //角色维护
          {
            path: '/role',
            redirect: '/role/list'
          },
          {         
            path: '/role/list',
            name: 'role_list',
            component: role_list,
            meta: {
               requireAuth: true,
            },
          },
          //组维护
          {
            path: '/group',
            redirect: '/group/list'
          },
          {         
            path: '/group/list',
            name: 'group_list',
            component: group_list,
            meta: {
               requireAuth: true,
            },
          },
          {
            path: '/group',
            redirect: '/group/edit'
          },
          {         
            path: '/group/edit',
            name: 'group_edit',
            component: group_edit,
            meta: {
               requireAuth: true,
            },
          },
          //用户
          {
            path: '/user',
            redirect: '/user/list'
          },
          {         
            path: '/user/list',
            name: 'User',
            component: user_list,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/projectManagerMaintenance',
            name: 'projectManagerMaintenance',
            component: projectManagerMaintenance,
            meta: {
               requireAuth: false,
            },
          },
          {         
            path: '/configurationItem',
            name: 'configurationItem',
            component: configurationItem,
            meta: {
               requireAuth: false,
            },
          },
          //项目经理映射管理
          {
            path: '/manager',
            redirect: '/manager/list'
          },
          {         
            path: '/manager/list',
            name: 'manager_list',
            component: manager_list,
            meta: {
               requireAuth: true,
            },
          },
          {
            path: '/manager',
            redirect: '/manager/edit'
          },
          {         
            path: '/manager/edit',
            name: 'manager_edit',
            component: manager_edit,
            meta: {
               requireAuth: true,
            },
          },
          //项目
          {
            path: '/project',
            redirect: '/project/list'
          },
          {         
            path: '/project/list',
            name: 'project',
            component: project_list,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/project/add',
            name: 'project_add',
            component: project_add,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/project/edit',
            name: 'project_edit',
            component: project_edit,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/project/detail',
            name: 'project_detail',
            component: project_detail,
            meta: {
              requireAuth: false,
            }
          },
          {
            path: '/ipmsSource',
            redirect: '/project/source'
          },
          {         
            path: '/project/source',
            name: 'ipmsSource',
            component: project_source,
            meta: {
              requireAuth: false,
            }
          },
          //任务
          {
            path: '/task',
            redirect: '/task/list'
          },
          {         
            path: '/task/list',
            name: 'task',
            component: task_list,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/task/add',
            name: 'task_add',
            component: task_add,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/task/edit',
            name: 'task_edit',
            component: task_edit,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/task/detail',
            name: 'task_detail',
            component: task_detail,
            meta: {
              requireAuth: false,
            }
          },
          //子任务
          {
            path: '/subtask',
            redirect: '/subtask/list'
          },
          {         
            path: '/subtask/list',
            name: 'subtask',
            component: subtask_list,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/subtask/add',
            name: 'subtask_add',
            component: subtask_add,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/subtask/edit',
            name: 'subtask_edit',
            component: subtask_edit,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/subtask/detail',
            name: 'subtask_detail',
            component: subtask_detail,
            meta: {
              requireAuth: false,
            }
          },
          //工时
          {
            path: '/labour',
            redirect: '/labour/list'
          },
          {         
            path: '/labour/list',
            name: 'labour',
            component: labour_list,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/labour/add',
            name: 'labour_add',
            component: labour_add,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/labour/edit',
            name: 'labour_edit',
            component: labour_edit,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/labour/detail',
            name: 'labour_detail',
            component: labour_detail,
            meta: {
              requireAuth: false,
            }
          },
          //工程师工时列表页
          {
            path: '/labourEngineer',
            redirect: '/labourEngineer/list'
          },
          {         
            path: '/labourEngineer/list',
            name: 'labourEngineer',
            component: labour_engineer,
            meta: {
              requireAuth: false,
            }
          },
          //综合表单方式录入工时
          {
            path: '/labourEnter',
            redirect: '/labourEnter/enter'
          },
          {         
            path: '/labourEnter/enter',
            name: 'labourEnter',
            component: labour_enter,
            meta: {
              requireAuth: false,
            }
          },
          //基础数据
          {
            path: '/holiday',
            redirect: '/holiday/list'
          },
          {         
            path: '/holiday/list',
            name: 'holiday',
            component: holiday_list,
            meta: {
              requireAuth: false,
            }
          },
          //定时任务
          {
            path: '/cronJob',
            redirect: '/cronJob/list'
          },
          {         
            path: '/cronJob/list',
            name: 'cronJob',
            component: cronJob_list,
            meta: {
              requireAuth: false,
            }
          },
          //工程师工时报表
          {
            path: '/engineerReport',
            redirect: '/engineerReport/list'
          },
          {         
            path: '/engineerReport/list',
            name: 'engineerReport',
            component: engineerReport_list,
            meta: {
              requireAuth: false,
            }
          },
          //工时维度报表
          {
            path: '/labourReport',
            redirect: '/labourReport/list'
          },
          {         
            path: '/labourReport/list',
            name: 'labourReport',
            component: labourReport_list,
            meta: {
              requireAuth: false,
            }
          },
          //个人信息
          {
            path: '/personnel',
            redirect: '/personnel/list'
          },
          {         
            path: '/personnel/list',
            name: 'personnel',
            component: personnel_list,
            meta: {
              requireAuth: false,
            }
          },
          // 重大项目管理
          {         
            path: '/major',
            redirect: '/majorProject'
          },
          {         
            path: '/majorProject',
            name: 'majorProject',
            component: majorProjectQuery,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/project3S2S',
            name: 'project3S2S',
            component: project3S2S,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/projectApplication',
            name: 'projectApplication',
            component: majorProjectApplication,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/projectApproval',
            name: 'projectApproval',
            component: majorProjectApproval,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/formallyApprovedProject',
            name: 'formallyApprovedProject',
            component: majorFormallyApproved,
            meta: {
              requireAuth: false,
            }
          },
          {         
            path: '/commonDocuments',
            name: 'commonDocuments',
            component: commonDocuments,
            meta: {
              requireAuth: false,
            },
          },
          // 服务台帐
          {         
            path: '/keyFocusProjects',
            name: 'keyFocusProjects',
            component: keyFocusProjects,
            meta: {
              requireAuth: false,
            }
          },
          // 我的工作台
          {         
            path: '/workbench',
            redirect: '/toDo'
          },
          {         
            path: '/toDo',
            name: 'toDo',
            component: workbenchToDo,
            meta: {
              requireAuth: false,
            },
          },
          {         
            path: '/myFlow',
            name: 'myFlow',
            component: workbenchToDoMyFlow,
            meta: {
              requireAuth: false,
            },
          },
          {         
            path: '/flowQuery',
            name: 'flowQuery',
            component: workbenchFlowQuery,
            meta: {
              requireAuth: true,
            },
          },
          // 风险管理
          {         
            path: '/riskManagement',
            name: 'riskManagement',
            component: riskManagement,
            meta: {
              requireAuth: true,
            },
          },
          {
            path: '/riskDashboard',
            name: 'riskDashboard',
            component: riskDashboard,
            meta: {
              requireAuth: true,
            },
          },
          {
            path: '/riskAssessmentGuide',
            name: 'riskAssessmentGuide',
            component: riskAssessmentGuide,
            meta: {
              requireAuth: true,
            },
          },
          // 价值客户管理
          {         
            path: '/informationManagement',
            name: 'informationManagement',
            component: informationManagement,
            meta: {
              requireAuth: false,
            },
          },
          {         
            path: '/documentManagement',
            name: 'documentManagement',
            component: documentManagement,
            meta: {
              requireAuth: false,
            },
          },
          {         
            path: '/valuedAccountReport',
            name: 'valuedAccountReport',
            component: valuedAccountReport,
            meta: {
              requireAuth: false,
            },
          },
          {
            path: '/informationManagement/detail',
            name: 'accountDetail',
            component: accountDetail,
            meta: {
              requireAuth: false,
            },
          },
      ]
    },
    {
      path: '/satisfactionLevel',
      name: 'satisfactionLevel',
      component: satisfactionLevel,
    },
    {
      path: '/satisfactionLevelMarket',
      name: 'satisfactionLevelMarket',
      component: satisfactionLevelMarket,
    },
  ]
})

// 白名单路由：无需权限即可访问
const whiteList = ['/login', '/satisfactionLevel', '/satisfactionLevelMarket']

router.beforeEach((to, from, next) => {
  const islhToken = sessionStorage.getItem('islhtoken')
  // 访问根路径时，根据token状态跳转
  if (to.path === '/') {
    next({ path: islhToken ? '/indexw' : '/login' })
    return
  }

  

  // 白名单路由直接放行（startsWith匹配，支持带查询参数的路径如 /satisfactionLevel?guid=xxx）
  if (whiteList.some(item => to.path.startsWith(item))) {
    next()
    return
  }

  // 无token则跳转登录页，记录原目标路径
  if (!islhToken) {
    sessionStorage.setItem('redirectUrl', to.path.slice(1))
    next({ path: '/login' })
    return
  }

  // 有token时，检查菜单权限（allMenuList由侧边栏从后端获取后存入Vuex）
  const allMenuList = store.state.allMenuList

  // 如果菜单列表为空（侧边栏还没加载完），需要先加载菜单权限再校验
  // 目标是首页则直接放行；否则先跳首页让侧边栏加载菜单，加载完后根据redirectUrl自动跳转
  if (!allMenuList || allMenuList.length === 0) {
    if (to.path === '/indexw' || to.path === '/index') {
      next()
    } else {
      // 保留目标路径，等侧边栏菜单加载完后再根据权限决定是否跳转
      sessionStorage.setItem('redirectUrl', to.path.slice(1))
      next({ path: '/indexw' })
    }
    return
  }

  // 首页 indexw 默认放行
  if (to.path === '/indexw' || to.path === '/index') {
    next()
    return
  }

  // 从路径中提取菜单标识，逐段检查是否在用户菜单列表中
  const pathSegments = to.path.split('/').filter(Boolean)
  const hasPermission = pathSegments.some(segment => allMenuList.indexOf(segment) !== -1)

  // 检查目标路由是否在用户菜单列表中
  if (hasPermission) {
    next()
  } else {
    // 无权限访问，跳回首页
    next({ path: '/indexw' })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js